"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.sort.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.some.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _jsMd = _interopRequireDefault(require("js-md5"));
var _default = exports.default = {
  props: {},
  data: function data() {
    return {
      formTabs: {
        show: false,
        key: {
          t: '',
          b: ''
        },
        tabs: {
          t: [],
          b: []
        },
        // @todo 待删除 2023-01-10 08:53:32 废弃代码，因为旧项目还在使用，所以暂时不删除
        items: {
          t: [],
          b: []
        },
        dom: {
          t: {},
          b: {}
        }
      },
      isInitHight: false
    };
  },
  computed: {
    // getTabsTop() {
    //   return Object.keys(this.$scopedSlots).filter(keys => keys.includes('tabs-top-') || keys.includes('tabs-'))
    // },
    // getTabsBottom() {
    //   return Object.keys(this.$scopedSlots).filter(keys => keys.includes('tabs-bottom-'))
    // }
  },
  watch: {
    'formTabs.items.t': {
      handler: function handler(nv /* nv, ov */) {
        this.formTabs.show = this.$$isNoEmpty(nv);
      },
      deep: true
    },
    'formTabs.items.b': {
      handler: function handler(nv /* nv, ov */) {
        this.formTabs.show = this.$$isNoEmpty(nv);
      },
      deep: true
    },
    openDialog: {
      handler: function handler(nv) {
        var _this = this;
        if (nv) {
          this.computedTabsPane();
          this.setTabKey();
          this.$nextTick(function () {
            _this.setHeight();
            // this.
            // const d = this.$refs['wl-dialog-form-wrapper']?.$el?.querySelector('.el-dialog')
            // d.style.cssText += ';min-height: 100%;'
          });
        }
      },
      deep: true
    },
    'formTabs.key.t': {
      handler: function handler(nv) {
        if (!nv || nv === '0') this.setTabKey();
      }
    },
    'formTabs.key.b': {
      handler: function handler(nv) {
        if (!nv || nv === '0') this.setTabKey();
      }
    }
  },
  methods: {
    /** 计算 页签版面
      * @description: 计算页签
      * @return { void }
      */
    computedTabsPane: function computedTabsPane() {
      var _this2 = this;
      // 防止代码在执行的过程中重复执行
      this.inComputedTabsPane = true;
      this.$nextTick(function () {
        // 插槽
        var a = _this2.$slots;
        // 作用域插槽
        var b = _this2.$scopedSlots;

        // 所有页签面板
        var c = Object.keys(b).filter(function (k) {
          return k.includes('tabs-');
        });
        ['t', 'b'].forEach(function (tb) {
          var tabs = _this2.formTabs.tabs[tb];
          /* 获取完整单词 */
          var n0 = tb === 't' ? 'top' : 'bottom';
          var n1 = tb === 't' ? 'bottom' : 'top';

          // 页签
          var d = c.filter(function (k) {
            return !k.includes("tabs-".concat(n1)) && k.includes('tabs-');
          });
          // 默认页签
          var e = d.filter(function (k) {
            return k === "tabs-".concat(n0);
          });
          // 非标准页签
          var f = d.filter(function (k) {
            var _b$k;
            return k !== "tabs-".concat(n0) && ((_b$k = b[k]) === null || _b$k === void 0 ? void 0 : _b$k.name) === '';
          });
          // 标准页签
          var g = d.filter(function (k) {
            var _b$k2;
            return k !== "tabs-".concat(n0) && ((_b$k2 = b[k]) === null || _b$k2 === void 0 ? void 0 : _b$k2.name) === 'normalized';
          });
          tabs.length = 0;
          var forEachFun = function forEachFun(k) {
            var _b$k3;
            /* 如果默认页签是标准页签 */
            if (((_b$k3 = b[k]) === null || _b$k3 === void 0 ? void 0 : _b$k3.name) === '') {
              a[k].forEach(function (VNode) {
                var _VNode$data, _ref, _attrs$sortIndex;
                var attrs = VNode === null || VNode === void 0 || (_VNode$data = VNode.data) === null || _VNode$data === void 0 ? void 0 : _VNode$data.attrs;
                var label = attrs === null || attrs === void 0 ? void 0 : attrs.label;
                var sortIndex = (_ref = (_attrs$sortIndex = attrs === null || attrs === void 0 ? void 0 : attrs.sortIndex) !== null && _attrs$sortIndex !== void 0 ? _attrs$sortIndex : attrs === null || attrs === void 0 ? void 0 : attrs.sort) !== null && _ref !== void 0 ? _ref : null;
                if (label) {
                  var name = "tabs-".concat(n0, "-") + (0, _jsMd.default)(label);
                  if (_this2.$slots[name]) _this2.$slots[name].push(VNode);else {
                    _this2.$slots[name] = [VNode];
                    tabs.push({
                      name: name,
                      label: label,
                      sortIndex: sortIndex,
                      VNode: VNode
                    });
                  }
                }
              });
            } else if (!tabs.find(function (tab) {
              return tab.name === k;
            })) tabs.push({
              name: k,
              label: '默认'
            });
          };

          /* 处理默认页签 */
          e.forEach(forEachFun);

          /* 处理非标准页签 */
          f.forEach(forEachFun);

          /* 处理标准页签 */
          g.forEach(function (k) {
            var label = k.replace(/(tabs-top-|tabs-bottom-|tabs-)+/g, '');
            var name = k;
            tabs.push({
              name: name,
              label: label
            });
          });

          // 排序
          tabs.$$sort('sortIndex');

          // - #Todo 2023-01-09 15:10:47 setFormTabs 即将废弃的方法
          _this2.setFormTabs();
          _this2.inComputedTabsPane = false;
        });
      });
    },
    /** 更新 页签版面
      * @description: 防止页面在更新之后，插槽消失
      * @return { void }
      */
    updateTabsPane: function updateTabsPane() {
      if (this.inComputedTabsPane) return;
      var tabs = this.formTabs.tabs;
      // 插槽
      var a = this.$slots;
      // 作用域插槽
      var b = this.$scopedSlots

      /* 如果插槽有失踪的，就重新计算 */;
      ['t', 'b'].some(function (tb) {
        return tabs[tb].some(function (tab) {
          return !a[tab.name] && !b[tab.name];
        });
      }) && this.computedTabsPane();
    },
    /** 判断是否有页签
      * @param { String } tb 判断的是上层还是下层 为空的时候同时判断上下， [ 't' - 上层, 'b' - 下层 ]
      * @return { Boolean } 是否有页签
      */
    haveTabs: function haveTabs(tb) {
      var a = false,
        b = false;
      if (!tb || tb === 't') a = this.$$isNoEmpty(this.getTabsTop());
      if (!tb || tb === 'b') b = this.$$isNoEmpty(this.getTabsBottom());
      return a || b;
    },
    /** 设置页签 key
      * @return { void }
      */
    setTabKey: function setTabKey() {
      var _this3 = this;
      this.$nextTick(function () {
        var a = _this3.formTabs.tabs;
        var b = _this3.formTabs.items;
        var c = _this3.formTabs.key;
        ['t', 'b'].forEach(function (tb) {
          if (a[tb].length > 0) c[tb] = a[tb][0].name;
          if (b[tb].length > 0) c[tb] = b[tb][0].name;
        });
      });
    },
    /** 初始高度
      * @description: 初始高度
      * @return { void }
      */
    setHeight: function setHeight() {
      var _this$$refs$wlDialog, _b$style;
      if (!(this.$$isNoEmpty(this.getTabsTop()) && this.$$isNoEmpty(this.getTabsBottom()))) return;
      var a = (_this$$refs$wlDialog = this.$refs['wl-dialog-form-wrapper']) === null || _this$$refs$wlDialog === void 0 ? void 0 : _this$$refs$wlDialog.$el;
      var b = a === null || a === void 0 ? void 0 : a.querySelector('.el-dialog');
      /* 如果上下标签都存在的时候，让 dialog 高度最大化 */
      !(b !== null && b !== void 0 && (_b$style = b.style) !== null && _b$style !== void 0 && (_b$style = _b$style.cssText) !== null && _b$style !== void 0 && _b$style.includes('height')) && (b === null || b === void 0 ? void 0 : b.style) && (b.style.cssText += ";height: auto;max-height: ".concat(this.$$getDomSize(a, 'height') - this.$$getDomSize(a, 'padding-top') - this.$$getDomSize(a, 'padding-bottom'), "px;"));
      var c = this.$refs['wl-dialog-form-button'];
      var d = this.$refs['wl-dialog-form'];
      if (!c) (d === null || d === void 0 ? void 0 : d.$el) && (d.$el.style.cssText += ';min-height: 100%;');else {
        var h = this.$$getDomSize(c, 'height') + this.$$getDomSize(c, 'margin-top') + this.$$getDomSize(c, 'margin-bottom');
        d.$el.style.cssText += ";min-height: calc(100% - ".concat(h, "px);");
      }
    },
    /** 判断是否有页签
      * @param { String } tb 判断的是上层还是下层 [ 't' - 上层 (默认), 'b' - 下层 ]
      * @return { Array } 是否有页签
      */
    getTabs: function getTabs(tb) {
      switch (tb) {
        case 'b':
          return this.getTabsBottom();
        case 't':
        default:
          return this.getTabsTop();
      }
    },
    getTabsTop: function getTabsTop() {
      var _this$formTabs$tabs$t;
      return (_this$formTabs$tabs$t = this.formTabs.tabs.t) !== null && _this$formTabs$tabs$t !== void 0 ? _this$formTabs$tabs$t : [];
    },
    getTabsBottom: function getTabsBottom() {
      var _this$formTabs$tabs$b;
      return (_this$formTabs$tabs$b = this.formTabs.tabs.b) !== null && _this$formTabs$tabs$b !== void 0 ? _this$formTabs$tabs$b : [];
    },
    /** 设置 表单 页签组件
     * @description: 设置 表单 页签组件
     * @return { void }
     */
    setFormTabs: function setFormTabs() {
      var _this4 = this;
      this.$$debounce(function () {
        _this4.$nextTick(function () {
          var a = _this4.$refs['wl-dialog-form'];
          var b = _this4.$refs['form-wrapper'];
          // const c = this.$refs['form-tabs-wrapper']
          if (a && b) {
            var c = {
              t: b.querySelectorAll('[tabs-top]'),
              b: b.querySelectorAll('[tabs-bottom]')
            };
            // eslint-disable-next-line no-unused-vars
            var _loop = function _loop() {
              var d = c[k];
              var n = '';
              if (k === 't') n = 'top';else if (k === 'b') n = 'bottom';
              d.forEach(function (dom) {
                var an = dom.getAttribute("tabs-".concat(n));
                // const key = getMD5(an ?? dom?.innerHTML)
                // const r = !this.formTabs.items[k]
                //   .map(i => i.label)
                //   .includes(an)
                //
                // if (r) {
                //   this.formTabs.items[k].push({ label: an, name: key })
                //   this.formTabs.dom[k][key] = dom
                // }

                // eslint-disable-next-line no-console
                console.error("\u5F53\u524D\u9875\u7B7E\u5DF2\u5E9F\u5F03\uFF01\uFF01\uFF01\uFF01\n\u5E9F\u5F03\u5199\u6CD5\uFF1A\n", dom, "\n\n\u8BF7\u53D8\u66F4\u5199\u6CD5\uFF1A\nhtml \u5199\u6CD5\uFF1A\n<div slot=\"tabs-top\" label=\"".concat(an, "\">\npug \u5199\u6CD5\uFF1A\ndiv(slot=\"tabs-top\" label=\"").concat(an, "\")"), "\n\n\u65B0\u7684\u9875\u7B7E\u5199\u6CD5\u6807\u7B7E\u5C06\u652F\u6301\u6392\u5E8F(\u6392\u5E8F\u5C5E\u6027\uFF1AsortIndex=\"\")\uFF0C\u5E8F\u53F7\u8D8A\u5927\uFF0C\u8D8A\u9760\u524D", "\nhtml \u5199\u6CD5\uFF1A\n<div slot=\"tabs-top\" label=\"".concat(an, "\" sortIndex=\"\">\npug \u5199\u6CD5\uFF1A\ndiv(slot=\"tabs-top\" label=\"").concat(an, "\" sortIndex=\"\")"));
              });
              b.querySelectorAll('[tabs-top], [tabs-bottom]').forEach(function (dom) {
                return dom.remove();
              });
              // /* 挂载元素 */
              // this.$nextTick(() => {
              //   const doms = this.formTabs.dom[k]
              //   if (this.$$dataTypeOf(doms) === 'object') {
              //     const domParent = this.$refs[`form-tabs-${k}-pane`]
              //     domParent?.forEach(domP => {
              //       const key = domP.$el?.getAttribute('aria-labelledby')?.split('-')[1]
              //       domP.$el?.appendChild(this.formTabs.dom[k][key])
              //     })
              //   }
              // })
            };
            for (var k in c) {
              _loop();
            }
          }
        });
      });
    }
  }
};